import React from 'react';
import parse from 'html-react-parser';
import { useAppSelector } from '../store/hooks';
import { useSwipe } from '../store/useSwipe';
const AboutUs: React.FC = () => {
const { onTouchStart, onTouchMove, onTouchEnd } = useSwipe();
    const darkMode = useAppSelector((state: any) => state.categoryNavigation.darkmode);
    const headerHeight = useAppSelector((state: any) => state.categoryNavigation.headerHeight || 0);
    const fooNavHeight = useAppSelector((state: any) => state.categoryNavigation.fooNavHeight || 0);
    const fontSize = useAppSelector((state: any) => state.categoryNavigation.fontsize);
    const staticData = useAppSelector((state: any) => state.staticSettingSlice.data);    

  return (
     <div className={`font-sans min-h-screen ${darkMode ? 'bg-gray-900 text-white' : 'bg-gray-100 text-gray-900'}`}>
        <main
        className="home-container"       
       style={{ height: `calc(100vh - ${fooNavHeight+10}px)`, overflowY: 'auto', paddingTop:headerHeight+10}}
        onTouchStart={onTouchStart}
        onTouchMove={onTouchMove}
        onTouchEnd={onTouchEnd}>
    
      <div className="max-w-4xl mx-auto space-y-4 px-3">

        {/* Page Header */}
        <h1 className={`font-bold mb-0 ${fontSize === 'small' ? 'text-lg' : fontSize === 'large' ? 'text-2xl' : 'text-xl'}`}>
                      {staticData?.heading_about_us}
        </h1>

        {/* Directors Block */}
        <div className={`rounded-2xl shadow-md p-6 md:p-10 ${darkMode ? 'bg-gray-800' : 'bg-white'}`}>
         {parse(staticData?.text_about_us || '')}
        </div>

       
      </div>
      </main>
    </div>
  );
};

export default AboutUs;